/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 11/23/14
 * Time: 2:04 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var Backbone = require("backbone");

    // constants

    var TopBarNotificationModel = Backbone.Model.extend({
        defaults: {

        },
        name: "TopBarNotificationModel"
    });

//    var structure = {
//        notification: {
//            id: "1",
//            type: "error",
//            contentOptions: {
//                title:"",
//                text: "",
//                buttonCaption: "Connect to Google",
//                buttonCallback: "",
//                buttonPermutation:""
//            },
//            viewOptions: {
//                getContentViewCallBack: ""
//            },
//            onShow: "",
//            onClose: ""
//
//        }
//    }
    return TopBarNotificationModel;
});
